module.exports = __webpack_public_path__ + "img/1.7a3f4635.jpg";